import React from "react";
import { SEO } from "../components/SEO";
import { BIZ } from "../lib/constants";

export default function Privacy() {
    return (
        <>
            <SEO
                title="Privacy Policy"
                description="How Liquor Studio collects, uses, and protects information about visitors and customers."
                path="/privacy"
            />

            <section
                style={{ paddingTop: 160, paddingBottom: 64, borderBottom: "1px solid var(--ls-border)" }}
            >
                <div className="ls-container max-w-3xl">
                    <span className="eyebrow">Legal</span>
                    <h1
                        className="font-display mt-5 text-white"
                        style={{
                            fontSize: "clamp(40px, 6vw, 64px)",
                            fontWeight: 500,
                            lineHeight: 1.05,
                            letterSpacing: "-0.02em",
                        }}
                    >
                        Privacy Policy
                    </h1>
                    <p className="mt-4 text-sm" style={{ color: "var(--ls-text-muted)" }}>
                        Last updated: February 1, 2026
                    </p>
                </div>
            </section>

            <section className="section-y" data-testid="privacy-content">
                <div
                    className="ls-container max-w-3xl"
                    style={{ color: "var(--ls-text-secondary)", fontSize: 16, lineHeight: 1.8 }}
                >
                    <p>
                        Liquor Studio ("we", "us", "our") respects your privacy. This Privacy Policy
                        explains what we collect, how we use it, and your rights.
                    </p>

                    <h2 className="font-display text-white mt-12" style={{ fontSize: 26, fontWeight: 500 }}>
                        Information we collect
                    </h2>
                    <ul className="mt-4 space-y-2 list-disc pl-6">
                        <li>
                            <strong className="text-white">Contact submissions:</strong> If you contact
                            us, we collect the email address and message you provide.
                        </li>
                        <li>
                            <strong className="text-white">Newsletter:</strong> If you opt in, we
                            collect your email address to send promotional content.
                        </li>
                        <li>
                            <strong className="text-white">Analytics:</strong> We use privacy-respecting
                            analytics to understand site usage (pages visited, device type). We do not
                            sell or share this data.
                        </li>
                        <li>
                            <strong className="text-white">Cookies:</strong> We use minimal cookies and
                            localStorage — primarily to remember your age-gate confirmation for 30 days.
                        </li>
                    </ul>

                    <h2 className="font-display text-white mt-12" style={{ fontSize: 26, fontWeight: 500 }}>
                        How we use information
                    </h2>
                    <p className="mt-4">
                        We use the information you provide to respond to inquiries, send the
                        newsletter you opted into, and improve our website experience.
                        <strong className="text-white"> We do not sell your personal data. </strong>
                        We do not share your data with third parties for their marketing purposes.
                    </p>

                    <h2 className="font-display text-white mt-12" style={{ fontSize: 26, fontWeight: 500 }}>
                        Your rights
                    </h2>
                    <p className="mt-4">
                        You may request a copy of the data we hold about you, ask us to correct it,
                        or ask us to delete it. To exercise any of these rights, email{" "}
                        <a href={`mailto:${BIZ.email}`} className="link-underline text-white">
                            {BIZ.email}
                        </a>.
                    </p>

                    <h2 className="font-display text-white mt-12" style={{ fontSize: 26, fontWeight: 500 }}>
                        Children
                    </h2>
                    <p className="mt-4">
                        Our site is intended for adults aged 21 and older. We do not knowingly
                        collect information from anyone under 21. If you believe a minor has
                        provided us with information, please contact us so we can delete it.
                    </p>

                    <h2 className="font-display text-white mt-12" style={{ fontSize: 26, fontWeight: 500 }}>
                        Contact
                    </h2>
                    <p className="mt-4">
                        Questions about this policy? Email{" "}
                        <a href={`mailto:${BIZ.email}`} className="link-underline text-white">
                            {BIZ.email}
                        </a>{" "}
                        or call{" "}
                        <a href={`tel:${BIZ.phoneTel}`} className="link-underline text-white">
                            {BIZ.phone}
                        </a>.
                    </p>
                </div>
            </section>
        </>
    );
}
